import type { IMobileHandlerParams, IDesktopHandlerParams } from './models';

/**
 * Создает обработчик выбора категории для мобильной версии
 */
export const createMobileCategoryHandler = ({
    payload,
    setTempSelectedCategories,
    tempSelectedCategories,
}: IMobileHandlerParams) => {
    if (payload.initiator === null) {
        setTempSelectedCategories([]);

        return;
    }

    const selectedID = payload.initiator.key;
    const { isItemSelected } = payload.initiator.value;
    const categoryText = String(payload.initiator?.value.text || '');

    setTempSelectedCategories(currentCategories => {
        const filteredCategories = currentCategories.filter(el => el.id !== selectedID);

        // Если категория была в списке и чекбокс отмечен - удаляем
        if (filteredCategories.length !== tempSelectedCategories.length && isItemSelected) {
            return filteredCategories;
        }

        // Если категории не было в списке и чекбокс не отмечен - добавляем
        if (filteredCategories.length === tempSelectedCategories.length && !isItemSelected) {
            return [...currentCategories, { id: selectedID, text: categoryText }];
        }

        return currentCategories;
    });
};

/**
 * Создает обработчик выбора категории для десктопной версии
 */
export const createDesktopCategoryHandler = ({
    payload,
    setSelectedCategories,
}: IDesktopHandlerParams) => {
    if (payload.initiator === null) {
        setSelectedCategories([]);

        return;
    }

    const selectedID = payload.initiator.key;
    const { isItemSelected } = payload.initiator.value;
    const categoryText = String(payload.initiator?.value.text || '');

    setSelectedCategories(currentCategories => {
        const filteredCategories = currentCategories.filter(el => el.id !== selectedID);

        if (isItemSelected) {
            return filteredCategories;
        }

        return [...currentCategories, { id: selectedID, text: categoryText }];
    });
};
